export const getApiUrl = (): string => {
  const baseURL = process.env.REACT_APP_DOMAIN || '';
  return `${baseURL}/api/`;
};
